$(document).ready(function(){
	$(".contenido-square .contenido-round").on("click", function(){
		if ($(this).hasClass("contenido-round-1")) {
			if ($(".contenido-square .container-contenido").hasClass("showContenido1")) {
				$(".contenido-square .container-contenido").attr("class", "container-contenido showNothing");
				$(".contenido-square .background-container").css("background-image", "none");
			} else {
				$(".contenido-square .container-contenido").attr("class", "container-contenido showContenido1");
				var background = $(this).find("img.background");
				if (background.length > 0){
					$(".contenido-square .background-container").css("background-image", "url(" + background.attr("src") + ")");
				} else {
					$(".contenido-square .background-container").css("background-image", "none");
				}
			}
		}

		else if ($(this).hasClass("contenido-round-2")) {
			if ($(".contenido-square .container-contenido").hasClass("showContenido2")) {
				$(".contenido-square .container-contenido").attr("class", "container-contenido showNothing");
				$(".contenido-square .background-container").css("background-image", "none");
			} else {
				$(".contenido-square .container-contenido").attr("class", "container-contenido showContenido2");
				var background = $(this).find("img.background");
				if (background.length > 0){
					$(".contenido-square .background-container").css("background-image", "url(" + background.attr("src") + ")");
				} else {
					$(".contenido-square .background-container").css("background-image", "none");
				}
			}
		}
		else if ($(this).hasClass("contenido-round-3")) {
			if ($(".contenido-square .container-contenido").hasClass("showContenido3")) {
				$(".contenido-square .container-contenido").attr("class", "container-contenido showNothing");
				$(".contenido-square .background-container").css("background-image", "none");
			} else {
				$(".contenido-square .container-contenido").attr("class", "container-contenido showContenido3");
				var background = $(this).find("img.background");
				if (background.length > 0){
					$(".contenido-square .background-container").css("background-image", "url(" + background.attr("src") + ")");
				} else {
					$(".contenido-square .background-container").css("background-image", "none");
				}
			}
		}
		else {
			if ($(".contenido-square .container-contenido").hasClass("showContenido4")) {
				$(".contenido-square .container-contenido").attr("class", "container-contenido showNothing");
				$(".contenido-square .background-container").css("background-image", "none");
			} else {
				$(".contenido-square .container-contenido").attr("class", "container-contenido showContenido4");
				var background = $(this).find("img.background");
				if (background.length > 0){
					$(".contenido-square .background-container").css("background-image", "url(" + background.attr("src") + ")");
				} else {
					$(".contenido-square .background-container").css("background-image", "none");
				}
			}
		}
		$(".contenido-square").trigger("click");
	})
})